import React, { useState, useEffect } from "react";
import { Row, Col, Select, Form } from "antd";
import { IonLabel } from "@ionic/react";

import { useTranslation } from "react-i18next";
import cityOptions from "../../data/city";

const { Option } = Select;

const City = ({ state = {}, ...props }) => {
  const { data, form, rules, onChange } = state;
  const { t, i18n } = useTranslation();

  //for sync antd with state
  useEffect(() => {
    form?.setFieldsValue({ "address.city": data });
  }, [data]);

  return (
    <Row {...props}>
      <Col span={6}>
        <IonLabel style={{ fontSize: "1rem" }}>{t("newVendor.city")}&nbsp;</IonLabel>
      </Col>
      <Col span={18}>
        <Form form={form} layout="vertical" style={{ width: "100%" }}>
          <Form.Item name="address.city" rules={rules}>
            <Select
              value={data}
              showSearch
              size="large"
              style={{ width: 200 }}
              optionFilterProp="children"
              filterOption={(input, option) => {
                // console.log(input.toLowerCase(), option.children.toLowerCase());
                return option.children.toLowerCase().includes(input.toLowerCase()); // substr search
              }}
              filterSort={(optionA, optionB) =>
                optionA.children.toLowerCase().localeCompare(optionB.children.toLowerCase())
              }
              onChange={(value) => {
                onChange({ address: { city: value } });
              }}
            >
              {cityOptions.map((city, i) => (
                <Option key={i} value={city.id}>
                  {city.label}
                </Option>
              ))}
            </Select>
          </Form.Item>
        </Form>
      </Col>
    </Row>
  );
};

export default City;
